import { AxiosHeaders, AxiosHeaderValue, AxiosResponse } from 'axios';

export default function readHeader(
  res: AxiosResponse,
  name: string
): AxiosHeaderValue {
  const h = res.headers as AxiosHeaders | Record<string, string>;

  if (typeof (h as AxiosHeaders).get === 'function') {
    return (h as AxiosHeaders).get(name);
  }
  return (h as Record<string, string>)[name.toLowerCase()];
}
